<mat-card *ngIf="user">
  <mat-card-header>
    <mat-card-title>Zahlung</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-radio-group [(ngModel)]="betrag">
      <table>
        <tr *ngIf="user.faelligerBetrag > 0">
          <td>
            <mat-radio-button [value]="user.faelligerBetrag" color="primary">
              Fälliger Betrag:
            </mat-radio-button>
          </td>
          <td>{{user.faelligerBetrag | preis}}</td>
        </tr>
        <tr *ngIf="user.offenerBetrag && user.offenerBetrag !== user.faelligerBetrag">
          <td>
            <mat-radio-button [value]="user.offenerBetrag" color="primary">
              Offener Betrag:
            </mat-radio-button>
          </td>
          <td>{{user.offenerBetrag | preis}}</td>
        </tr>
        <tr>
          <td>
            <mat-radio-button [value]="0" color="primary">
              Eigener Betrag:
            </mat-radio-button>
          </td>
          <td>
            <input [(ngModel)]="eigenerBetrag" type="number" [min]="eigenerBetragMin" size="4" maxlength="4">
          </td>
        </tr>
      </table>
    </mat-radio-group>

    <app-paypal-button *ngIf="betrag || eigenerBetrag >= eigenerBetragMin" [betrag]="betrag ? betrag : eigenerBetrag">
    </app-paypal-button>
    <br>

    <div class="alert alert-info" *ngIf="user.guthaben > 0">{{service.texte.hinweisGuthaben(user.guthaben)}}</div>
  </mat-card-content>
</mat-card>
